import {Routes} from '@angular/router';
import {ROUTES as AUTH_ROUTE } from '@modules/authentication/authentication-routing.module';
import {ROUTES as PAGE_ROUTE} from '@modules/pages/page-routing.module';

export const FULL_LAYOUT_ROUTES: Routes = [
    {
        path: AUTH_ROUTE.PREFIX,
        loadChildren: () => import('../../modules/authentication/authentication.module').then(m => m.AuthenticationModule)
    },
    {
      path: PAGE_ROUTE.PREFIX,
      loadChildren: () => import('../../modules/pages/page.module').then(m => m.PageModule)
    }
];
